export default "__VITE_ASSET__1fa0a8d2__"